import React, {useState} from 'react';
import {InputNumber} from "primereact/inputnumber";
import {InputSwitch} from "primereact/inputswitch";
import {classNames} from "primereact/utils";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {setCompanyField, setChangedCompaniesData} from "../../../redux/actions/actions";
import {Button} from "primereact/button";
import {ConfirmDialog} from "primereact/confirmdialog";
import {getDefaultAmdSettings} from "../../../redux/api/api";

const CampaignDialogAMD = () => {
    const dispatch = useAppDispatch();
    const companiesData = useAppSelector(state => state.CompaniesListReducer.companiesData);
    const archiveTableToggle = useAppSelector(state => state.CompaniesListReducer.archiveTableToggle);
    const editType = useAppSelector(state => state.UsersReducer.editType);
    const errorFields = useAppSelector(state => state.CompaniesListReducer.errorFields);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const statusDone = companiesData?.campaign?.statusId === 6;

    const [showResetAmdConfirm, setShowResetAmdConfirm] = useState(false);

    const amd = companiesData?.campaignAMD;
    const amdErrors = errorFields?.campaignAMD as Record<string, string> | undefined;

    const updateField = (fieldName: string, value: any) => {
        dispatch(setCompanyField({section: 'campaignAMD', fieldName, value}));
        dispatch(setChangedCompaniesData(true));
    };

    const isDisabled = !archiveTableToggle || statusDone || !editType;

    const hangupList: string[] = amd?.hangup_on_machine ?? [];

    const toggleHangup = (key: string, checked: boolean) => {
        const updated = checked
            ? [...hangupList, key]
            : hangupList.filter((item: string) => item !== key);
        updateField('hangup_on_machine', updated);
    };

    return (
        <div className="acd-settings grid">
            <div className="p-fluid grid col-12 md:col-12">
                <div className="field col-12 md:col-6 mb-0">
                    <div className="field-radiobutton flex align-items-center">
                        <InputSwitch
                            checked={companiesData?.campaign?.isAMD ?? false}
                            disabled={isDisabled}
                            onChange={(e) => {
                                dispatch(setCompanyField({section: 'campaign', fieldName: 'isAMD', value: e.value}));
                                dispatch(setChangedCompaniesData(true));
                            }}
                        />
                        <label className="ml-2 mb-0">Увімкнути AMD</label>
                    </div>
                </div>
                <div className="field col-12 md:col-6 mb-0 flex justify-content-end">
                    {/*<div className="field-radiobutton flex align-items-center">*/}
                    {/*    <InputSwitch*/}
                    {/*        checked={amd?.aiEnabled ?? false}*/}
                    {/*        disabled={isDisabled}*/}
                    {/*        onChange={(e) => updateField('aiEnabled', e.value)}*/}
                    {/*    />*/}
                    {/*    <label className="ml-2 mb-0">Штучний інтелект</label>*/}
                    {/*</div>*/}
                    <Button
                        label="Дефолтні налаштування"
                        icon="pi pi-history"
                        className="w-16rem"
                        disabled={isDisabled}
                        onClick={() => setShowResetAmdConfirm(true)}
                    />
                </div>
            </div>

            {companiesData?.campaign?.isAMD && (
            <>
            <div className="p-fluid grid col-12 md:col-12">
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.maximum_number_of_words})}>Максимальна кількість слів в привітанні</label>
                    <InputNumber
                        value={amd?.maximum_number_of_words ?? null}
                        onValueChange={(e) => updateField('maximum_number_of_words', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.maximum_number_of_words})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.maximum_number_of_words && <small className="p-error">{amdErrors.maximum_number_of_words}</small>}
                </div>
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.between_words_silence})}>Тривалість тиші між словами (мс)</label>
                    <InputNumber
                        value={amd?.between_words_silence ?? null}
                        onValueChange={(e) => updateField('between_words_silence', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.between_words_silence})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.between_words_silence && <small className="p-error">{amdErrors.between_words_silence}</small>}
                </div>
            </div>

            <div className="p-fluid grid col-12 md:col-12">
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.maximum_word_length})}>Максимальна тривалість речення (мс)</label>
                    <InputNumber
                        value={amd?.maximum_word_length ?? null}
                        onValueChange={(e) => updateField('maximum_word_length', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.maximum_word_length})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.maximum_word_length && <small className="p-error">{amdErrors.maximum_word_length}</small>}
                </div>
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.min_word_length})}>Мінімальна пропозиція неперервного звуку голосу (мс)</label>
                    <InputNumber
                        value={amd?.min_word_length ?? null}
                        onValueChange={(e) => updateField('min_word_length', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.min_word_length})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.min_word_length && <small className="p-error">{amdErrors.min_word_length}</small>}
                </div>
            </div>

            <div className="p-fluid grid col-12 md:col-12">
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.total_analysis_time})}>Максимальний час для розпізнавання (мс)</label>
                    <InputNumber
                        value={amd?.total_analysis_time ?? null}
                        onValueChange={(e) => updateField('total_analysis_time', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.total_analysis_time})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.total_analysis_time && <small className="p-error">{amdErrors.total_analysis_time}</small>}
                </div>
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.silence_threshold})}>Максимальний поріг тиші (мс)</label>
                    <InputNumber
                        value={amd?.silence_threshold ?? null}
                        onValueChange={(e) => updateField('silence_threshold', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.silence_threshold})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.silence_threshold && <small className="p-error">{amdErrors.silence_threshold}</small>}
                </div>
            </div>

            <div className="p-fluid grid col-12 md:col-12">
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.after_greeting_silence})}>Тривалість тиші після привітання (мс)</label>
                    <InputNumber
                        value={amd?.after_greeting_silence ?? null}
                        onValueChange={(e) => updateField('after_greeting_silence', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.after_greeting_silence})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.after_greeting_silence && <small className="p-error">{amdErrors.after_greeting_silence}</small>}
                </div>
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.greeting})}>Максимальна довжина привітання (мс)</label>
                    <InputNumber
                        value={amd?.greeting ?? null}
                        onValueChange={(e) => updateField('greeting', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.greeting})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.greeting && <small className="p-error">{amdErrors.greeting}</small>}
                </div>
            </div>

            <div className="p-fluid grid col-12 md:col-12">
                <div className="field col-12 md:col-6 mb-0">
                    <label className={classNames({'p-error': amdErrors?.initial_silence})}>Максимальна тривалість тиші перед привітанням (мс)</label>
                    <InputNumber
                        value={amd?.initial_silence ?? null}
                        onValueChange={(e) => updateField('initial_silence', e.value)}
                        useGrouping={false}
                        className={classNames({'p-invalid': amdErrors?.initial_silence})}
                        disabled={isDisabled}
                        min={0}
                        placeholder="0"
                    />
                    {amdErrors?.initial_silence && <small className="p-error">{amdErrors.initial_silence}</small>}
                </div>
            </div>

            <div className="p-fluid grid col-12 md:col-12 mt-3">
                <div className="field col-6 md:col-3 mb-0">
                    <div className="field-radiobutton flex align-items-center">
                        <InputSwitch
                            checked={hangupList.includes('MAXWORDLENGTH')}
                            disabled={isDisabled}
                            onChange={(e) => toggleHangup('MAXWORDLENGTH', e.value)}
                        />
                        <label className={classNames('ml-2 mb-0 font-bold text-sm uppercase', {'p-error': amdErrors?.hangup_on_machine})}>Довжина слова</label>
                    </div>
                </div>
                <div className="field col-6 md:col-3 mb-0">
                    <div className="field-radiobutton flex align-items-center">
                        <InputSwitch
                            checked={hangupList.includes('MAXWORDS')}
                            disabled={isDisabled}
                            onChange={(e) => toggleHangup('MAXWORDS', e.value)}
                        />
                        <label className={classNames('ml-2 mb-0 font-bold text-sm uppercase', {'p-error': amdErrors?.hangup_on_machine})}>Ліміт слів</label>
                    </div>
                </div>
                <div className="field col-6 md:col-3 mb-0">
                    <div className="field-radiobutton flex align-items-center">
                        <InputSwitch
                            checked={hangupList.includes('LONGGREETING')}
                            disabled={isDisabled}
                            onChange={(e) => toggleHangup('LONGGREETING', e.value)}
                        />
                        <label className={classNames('ml-2 mb-0 font-bold text-sm uppercase', {'p-error': amdErrors?.hangup_on_machine})}>Довжина вітаня</label>
                    </div>
                </div>
                <div className="field col-6 md:col-3 mb-0">
                    <div className="field-radiobutton flex align-items-center">
                        <InputSwitch
                            checked={hangupList.includes('INITIALSILENCE')}
                            disabled={isDisabled}
                            onChange={(e) => toggleHangup('INITIALSILENCE', e.value)}
                        />
                        <label className={classNames('ml-2 mb-0 font-bold text-sm uppercase', {'p-error': amdErrors?.hangup_on_machine})}>Тиша</label>
                    </div>
                </div>
                {amdErrors?.hangup_on_machine && <div className="col-12"><small className="p-error">{amdErrors.hangup_on_machine}</small></div>}
            </div>
            </>
            )}

            <ConfirmDialog
                visible={showResetAmdConfirm}
                onHide={() => setShowResetAmdConfirm(false)}
                message="Конфігурація буде скинута до дефолтних налаштувань. Продовжити?"
                header="Підтвердження"
                icon="pi pi-question-circle"
                acceptLabel="Так"
                rejectLabel="Ні"
                accept={() => {
                    if (jwtToken?.jwtToken) {
                        dispatch(getDefaultAmdSettings(jwtToken.jwtToken));
                        dispatch(setChangedCompaniesData(true));
                    }
                    setShowResetAmdConfirm(false);
                }}
                reject={() => setShowResetAmdConfirm(false)}
            />
        </div>
    );
};

export default CampaignDialogAMD;
